/**
 * Связка пользователя 1ER и пользователя MAX. Запрос идёт на свой origin,
 * server.mjs проксирует его в региональный max-bot-service по origin.
 * perUserId бэкенд достаёт из JWT, поэтому в теле только maxUserId.
 */
export async function linkBotUser(
  maxUserId: string,
  accessToken: string
): Promise<void> {
  try {
    const res = await fetch('/bot-api/link-user', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({ maxUserId }),
    });

    if (!res.ok) {
      console.error('[linkBotUser] failed with status', res.status);
    }
  } catch (err) {
    console.error('[linkBotUser]', err);
  }
}
